// react components
import React from 'react'
import PhoneInput, {
    formatPhoneNumberIntl,
} from 'react-phone-number-input'

// styles
import 'react-phone-number-input/style.css'

// props
type PhoneNumberHelper825Props = {
    showFlag?: boolean
    value: string | undefined
}

// main
export const PhoneNumberHelper825: React.FC<PhoneNumberHelper825Props> = React.memo(({
    showFlag,
    value,
}) => {

    if (!value) return null

    if (showFlag) {
        return (
            <PhoneInput
                className='phone-number-helper-825'
                disabled
                onChange={() => undefined}
                // @ts-ignore
                value={value}
            />
        )
    }

    return (
        <span className="phone-number-helper">
            {/* @ts-ignore */}
            {formatPhoneNumberIntl(value)}
        </span>
    )
})
